<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Copyright</h1>
</div>
</div>
<h1 class="first" style="text-align: center;">
	Copyright</h1>
<p class="first" style="text-align: center;">
	Diversion Books<br/>
	A Division of Diversion Publishing Corp.<br/>
	443 Park Avenue South, Suite 1008<br/>
	New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="sectiontop" style="text-align: center;">
	Copyright © 2014 by Eileen Palma<br/>
	All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p class="sectiontop" style="text-align: center;">
	This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.</p>
<p class="sectiontop" style="text-align: center;">
	For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a></p>
<p class="sectiontop" style="text-align: center;">
	First Diversion Books edition April 2014<br/>
	ISBN: <span style="font-size: 1em; line-height: 1.375; font-family: 'Liberation Serif', serif; text-align: justify;">978-1-62681-278-9</span></p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<p class="sectiontop">
	For my parents, Liz and John, whose love story is still going strong forty years after my father tucked a diamond ring into the pocket of the new denim overalls he’d bought for my mother. And for my two sisters, Katie and Mary Beth. Who would have thought, after all the years of hair pulling and name calling that we would end up the best of friends?</p>
<p>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">For my husband, Doug, the love of my life and the best lead a romance writer could ask for. And our beautiful daughter Molly, one of the best writers I know—being your mom will always be my life’s most meaningful work.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap282256.vue?1d053824